if (!customElements.get('dh-event-calendar')) {
  customElements.define('dh-event-calendar', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.querySelectorAll('[data-event-grid]').forEach(grid => {
        if (!['upcoming', 'past'].includes(grid.dataset.eventGrid)) return;
        const direction = grid.dataset.eventGrid === 'past' ? -1 : 1;
        [...grid.children].sort((a, b) => direction * a.dataset.eventDate.localeCompare(b.dataset.eventDate)).forEach(card => grid.append(card));
      });
      const filters = this.querySelector('[data-event-filters]');
      filters.hidden = false;
      const search = this.querySelector('[data-event-search]');
      const available = this.querySelector('[data-event-availability]');
      const apply = () => {
        const query = search.value.trim().toLocaleLowerCase('da');
        let upcoming = 0;
        let visible = 0;
        this.querySelectorAll('[data-event-card]').forEach(card => {
          const match = card.dataset.eventTitle.toLocaleLowerCase('da').includes(query) && (!available.checked || (card.dataset.eventAvailable === 'true' && card.dataset.eventState !== 'past'));
          card.hidden = !match;
          if (match) visible++;
          if (match && card.dataset.eventState === 'upcoming') upcoming++;
        });
        this.querySelectorAll('[data-event-group]').forEach(group => { group.hidden = ![...group.querySelectorAll('[data-event-card]')].some(card => !card.hidden); });
        this.querySelector('[data-event-count]').textContent = `${upcoming} ${upcoming === 1 ? this.dataset.countLabelOne : this.dataset.countLabel}`;
        this.querySelector('[data-event-no-results]').hidden = visible > 0 || (!query && !available.checked);
      };
      search.addEventListener('input', apply);
      available.addEventListener('change', apply);
      apply();
    }
  });
}
